// import zoombt from '../assets/css/zoom/zoom-bootstrap.useable.css'
// import zoomrs from '../assets/css/zoom/zoom-react-select.useable.css'
//import zoomrs from '../assets/css/app.css'
import {
  Notification
} from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

import Vue from "vue";
import VueRouter from "vue-router";
import {
  findRouteNameByPath,
  manageMainLayoutConfig,
  getToken,
  setToken,
  canTurnTo,
  getConfigValueByKey
} from "@/libs/util";
import Layout from "../views/main/main.vue";
import store from '@/store'
import {
  hasOneOf
} from '@/libs/tools'
import config from '@/config'
const {
  mobApps
} = config;

//const 

const externalPages = ['register', 'activation', 'forgot', 'recover'];

Vue.use(VueRouter);

const routes = [{
    path: "/",
    name: "_home",
    redirect: '/home',
    component: Layout,
    meta: {
      login: true,
      hideInMenu: false,
    },
    // children: [{
    //     path: 'home',
    //     name: 'home',
    //     meta: {
    //       login: true,
    //       hideInMenu: false,          
    //       title: 'Эхлэл',
    //       notCache: true,
    //       icon: 'mdi-file-document-outline',
    //     },
    //     component: () => import("../views/home"),
    //   },
    //   {
    //     path: 'settings/:mode',
    //     name: 'settings',
    //     meta: {
    //       login: true,
    //       hideInMenu: true,

    //       title: 'Эхлэл',
    //       notCache: true,
    //       icon: 'mdi-file-document-outline',
    //     },
    //     component: () => import("../views/modules/sys/settings"),
    //   },
    //   {
    //     path: 'notification',
    //     name: 'notification',
    //     meta: {
    //       login: true,
    //       hideInMenu: true,

    //       title: 'Эхлэл',
    //       notCache: true,
    //       icon: 'mdi-file-document-outline',
    //     },
    //     component: () => import("../views/modules/sys/notification"),
    //   },
    //   {
    //     path: 'media/home',
    //     name: 'mediaHome',
    //     meta: {
    //       login: true,
    //       hideInMenu: false,
    //       access: ['media'],
    //       title: 'Динамик драйв',
    //       notCache: true,
    //       icon: 'mdi-file-document-outline',
    //     },
    //     component: () => import("../views/modules/media"),
    //   },
    // ]
  },
  {
    path: '/',
    name: '_master',
    //redirect: '/home',
    component: () => import("../views/main/main.vue"),

    children: [{
        path: "/login",
        name: "login",
        meta: {
          login: false,
          hideInMenu: true,
        },
        component: () => import("../views/auth/login")
      },
      {
        path: "/register",
        name: "register",
        meta: {
          login: false,
          hideInMenu: true,
        },
        component: () => import("../views/auth/register")
      },
      {
        path: "/forgot",
        name: "forgot",
        meta: {
          login: false,
          hideInMenu: true,
        },
        component: () => import("../views/auth/forgot")
      },
      {
        path: "/recover/:pk",
        name: "recover",
        meta: {
          login: false,
          hideInMenu: true,
        },
        component: () => import("../views/auth/recover")
      },
      {
        path: "/activation",
        name: "activation",
        meta: {
          login: false,
          hideInMenu: true,
        },
        component: () => import("../views/auth/activation")
      }
    ]
  },
  {
    path: "/404",
    name: "notfound",
    meta: {
      login: false,
      hideInMenu: true,
    },
    component: () => import("../views/modules/sys/notfound")
  },
  {
    path: "/401",
    name: "permissionDenied",
    meta: {
      login: false,
      hideInMenu: true,
    },
    component: () => import("../views/modules/sys/permissiondenied")
  },

  {
    path: "/landing/:id/:cid",
    name: "landingPage",
    component: () => import("../views/apps/web/index.vue"),
    meta: {
      header: false,
      login: false,
    }
  },
  {
    path: "/tads/:id/:cid",
    name: "landingTads",
    component: () => import("../views/apps/tads"),
    meta: {
      header: false,
      login: false,
    }
  },
  {
    path: "/mnuac",
    name: "mnuac",
    component: () => import("../views/apps/mnuac"),
    meta: {
      header: false,
      login: false,
    }
  },
  {
    path: "/help/:id/:cid",
    name: "landingHelp",
    component: () => import("../views/apps/help"),
    meta: {
      header: false,
      login: false,
    }
  },
  {
    path: "/exam/:courseId/:formId/:lessonId/:boxId/:boxOt",
    name: "examOnline",
    component: () => import("../views/main/exam.vue"),
    meta: {
      header: false,
      login: true,
    }
  },
  {
    path: "/lms/learnSurvey/:id/:name",
    name: "lmsSurvey",
    component: () => import("../views/modules/form/sanalAsuulga"),
    meta: {
      header: false,
      login: true,
    }
  },
  {
    path: "/examChart/:id/:ot",
    name: "examChart",
    component: () => import("../components/task/components/dialogs/examChartInPage.vue"),
    meta: {
      header: false,
      login: true,
    }
  },

  /*===================== VET MED  ==========================*/
  {
    path: "/vet-med",
    name: "vet-med",
    component: () => import("../views/apps/vet-med/landing/home.vue"),
    meta: {
      header: false,
      login: false,
    }
  },
  {
    path: "/vet-landing-help/:cid/:id",
    name: "vetLandingHelp",
    component: () => import("../views/apps/vet-med/landing/help.vue"),
    meta: {
      header: false,
      login: false,
    },
  },
  {
    path: "/vet-landing-meds",
    name: "vetLandingMeds",
    component: () => import("../views/apps/vet-med/landing/meds.vue"),
    meta: {
      login: false,
      hideInMenu: true,
      access: [],
    },
  },
  {
    path: "/vet-landing-lics",
    name: "vetLandingLics",
    component: () => import("../views/apps/vet-med/landing/lics.vue"),
    meta: {
      login: false,
      hideInMenu: true,
      access: [],
    },
  },

  /*===================== VET DRUG  ==========================*/
  {
    path: "/ia-vm-req",
    name: "_ia-vm-req",
    component: Layout,
    meta: {
      login: false,
      hideInMenu: true,
      access: [],
    },
    children: [{
        path: 'list/:ot',
        name: 'vetMedList',
        props: true,
        meta: {
          login: true,
          hideInMenu: true,
          access: [],
          title: 'Эхлэл',
          notCache: true,
          icon: 'mdi-file-document-outline',
          ot: 463,
        },
        component: () => import("../views/apps/vet-med/list.vue"),
      },
      {
        path: 'activemedcert/:ot',
        name: 'vetMedMy',
        props: true,
        meta: {
          login: true,
          hideInMenu: true,
          access: [],
          title: 'Эхлэл',
          notCache: true,
          icon: 'mdi-file-document-outline',
          ot: 478,
        },
        component: () => import("../views/apps/vet-med/list.vue"),
      },
      {
        path: 'law-db/:ot',
        name: 'vetMedLaw',
        props: true,
        meta: {
          login: true,
          hideInMenu: true,
          access: [],
          title: 'Эхлэл',
          notCache: true,
          icon: 'mdi-file-document-outline',
          ot: 487,
        },
        component: () => import("../views/apps/vet-med/list.vue"),
      },
      {
        path: 'law-juram/:ot',
        name: 'vetMedJuram',
        props: true,
        meta: {
          login: true,
          hideInMenu: true,
          access: [],
          title: 'Эхлэл',
          notCache: true,
          icon: 'mdi-file-document-outline',
          ot: 488,
        },
        component: () => import("../views/apps/vet-med/list.vue"),
      },
      {
        path: 'list/cert/:ot',
        name: 'vetMedListCert',
        props: true,
        meta: {
          login: true,
          hideInMenu: true,
          access: [],
          title: 'Эхлэл',
          notCache: true,
          icon: 'mdi-file-document-outline',
          ot: 464,
        },
        component: () => import("../views/apps/vet-med/list.vue"),
      },
      {
        path: 'list/lic/:ot',
        name: 'vetMedLics',
        props: true,
        meta: {
          login: true,
          hideInMenu: true,
          access: [],
          title: 'Эхлэл',
          notCache: true,
          icon: 'mdi-file-document-outline',
          ot: 467,
        },
        component: () => import("../views/apps/vet-med/list.vue"),
      },
      {
        path: 'list/req/:ot',
        name: 'vetMedListReq',
        props: true,
        meta: {
          login: true,
          hideInMenu: true,
          access: [],
          title: 'Эхлэл',
          notCache: true,
          icon: 'mdi-file-document-outline',
          ot: 465,
        },
        component: () => import("../views/apps/vet-med/list.vue"),
      },
      {
        path: 'medicine/:ot',
        name: 'vetMedMedicine',
        props: true,
        meta: {
          login: true,
          hideInMenu: true,
          access: [],
          title: 'Эхлэл',
          notCache: true,
          icon: 'mdi-file-document-outline',
          ot: 472,
        },
        component: () => import("../views/apps/vet-med/list.vue"),
      },
      {
        path: 'medicine-accepted-meds/:ot',
        name: 'vetMedAcceptedMeds',
        props: true,
        meta: {
          login: true,
          hideInMenu: true,
          access: [],
          title: 'Эхлэл',
          notCache: true,
          icon: 'mdi-file-document-outline',
          ot: 477,
        },
        component: () => import("../views/apps/vet-med/list.vue"),
      },
      {
        path: 'video-conference/:ot',
        name: 'vidConference',
        props: true,
        meta: {
          login: true,
          hideInMenu: true,
          access: [],
          title: 'Эхлэл',
          notCache: true,
          icon: 'mdi-file-document-outline',
          ot: 493,
        },
        component: () => import("../views/apps/vet-med/list.vue"),
      },
      {
        path: 'sys-reports/:ot',
        name: 'sysReports',
        props: true,
        meta: {
          login: true,
          hideInMenu: true,
          access: [],
          title: 'Эхлэл',
          notCache: true,
          icon: 'mdi-file-document-outline',
          ot: 451,
        },
        component: () => import("../views/modules/report"),
      },
      {
        path: 'medicine-accepted-org-license/:ot',
        name: 'vetMedAcceptedOrgLicences',
        props: true,
        meta: {
          login: true,
          hideInMenu: true,
          access: [],
          title: 'Эхлэл',
          notCache: true,
          icon: 'mdi-file-document-outline',
          ot: 476,
        },
        component: () => import("../views/apps/vet-med/list.vue"),
      },
      {
        path: 'medicine-accepted-samples/:ot',
        name: 'vetMedAcceptedSamples',
        props: true,
        meta: {
          login: true,
          hideInMenu: true,
          access: [],
          title: 'Эхлэл',
          notCache: true,
          icon: 'mdi-file-document-outline',
          ot: 481,
        },
        component: () => import("../views/apps/vet-med/list.vue"),
      },
      {
        path: 'list/special/:ot',
        name: 'vetMedSpecial',
        props: true,
        meta: {
          login: true,
          hideInMenu: true,
          access: [],
          title: 'Эхлэл',
          notCache: true,
          icon: 'mdi-file-document-outline',
          ot: 468,
        },
        component: () => import("../views/apps/vet-med/list.vue"),
      },
      {
        path: 'list/sample/:ot',
        name: 'vetMedSample',
        props: true,
        meta: {
          login: true,
          hideInMenu: true,
          access: [],
          title: 'Эхлэл',
          notCache: true,
          icon: 'mdi-file-document-outline',
          ot: 479,
        },
        component: () => import("../views/apps/vet-med/list.vue"),
      },
      {
        path: 'list/users/:ot',
        name: 'vetMedUsers',
        props: true,
        meta: {
          login: true,
          hideInMenu: true,
          access: [],
          title: 'Эхлэл',
          notCache: true,
          icon: 'mdi-file-document-outline',
          ot: 138,
        },
        component: () => import("../views/apps/vet-med/list.vue"),
      },
    ]
  },
];

const router = new VueRouter({
  mode: 'hash',
  //mode: 'history',
  routes
});

const turnTo = (to, access, next, withParam) => {
  //console.log('turnTo', to.name);
  let joinedRoutes = routes.concat(store.state.app.dynamicRoutes);
  store.dispatch('handleLoading', {
    isLoading: false
  });
  if (canTurnTo(to.name, access, joinedRoutes)) {
    if (to.name == 'login')
      manageMainLayoutConfig(to, store, true);
    else
      manageMainLayoutConfig(to, store);
    if (withParam != undefined && withParam)
      next({
        name: to.name,
        params: to.params
      })
    // else if(to.name == 'userProfile'){
    //   next({ name: to.name })
    // }
    else {
      next()
    }

  } else {
    manageMainLayoutConfig(to, store, true);
    next({
      replace: true,
      name: 'permissionDenied'
    })
  }
}

const turnLogin = (to, next, withParam) => {
  store.dispatch('handleLoading', {
    isLoading: false
  });
  manageMainLayoutConfig(to, store, true, true);
  setToken('')
  if (withParam != undefined && withParam)
    next({
      name: 'login',
    })
  else
    next()
}

const turnProfile = (to, next) => {
  Notification.info({
    message: 'Үндсэн мэдээлэл дутуу байна. Бөглөнө үү',
    title: "Мэдэгдэл",
    duration: 10000,
    type: "info",
    position: 'top-right',
    offset: 50
  });
  store.dispatch('handleLoading', {
    isLoading: false
  });
  manageMainLayoutConfig(to, store, true, true);
  next({
    name: 'userProfile',
  })
}

router.beforeEach((to, from, next) => {
  //console.log('next', next);
  if (window.zoomBackDisabled) {
    Notification.info({
      message: 'Дэлгэцийн баруун доод буланд байрлах Leave товч дээр дарж гарна уу',
      title: "Мэдэгдэл",
      duration: 6000,
      type: "info",
      position: 'top-left',
      offset: 50
    });
    next(false)
    return ''
  }

  store.dispatch('handleLoading', {
    isLoading: true
  });
  store.dispatch('resetResponsiveLayoutConfig', document)
  //resetResponsiveLayoutConfig(store, document);



  const token = getToken()
  let host; //= mobApps.filter(x => x.id == mobAppActiveGroup)[0];
  if (process.env.NODE_ENV === 'development') {
    let _host = mobApps.filter(x => x.hostDev != undefined && x.hostDev.includes(window.location.host));
    if (_host.length) {
      host = _host[0];
    }
  } else {
    let _host = mobApps.filter(x => x.hostPro != undefined && x.hostPro.includes(window.location.host));
    if (_host.length) {
      host = _host[0];
    }
  }

  if (store.state.app.activeGroup) {
    store.dispatch('handleActiveGroup', host);
  }

  if (!token) {
    //console.log('host.publicPage', host.publicPage);
    if (host.publicPage != undefined && host.publicPage.has) {
      store.dispatch('handleJWT', {
        key: host.key
      }).then(JWT => {
        if (JWT != false) {
          store.dispatch('handlePages', {
            store: store
          }).then(page => {
            if (page != false) {
              next({
                name: host.publicPage.route,
                params: {
                  id: store.state.app.homePageId,
                  cid: 0
                }
              })
            }
          });
          //# umnu iim bsan
          // next({
          //   name: host.publicPage.route
          // })
        } else {
          turnLogin(to, next, true);
        }

      });
    } else {
      //console.log("end irsen uu", to.name)
      if (hasOneOf(externalPages, [to.name])) {
        store.dispatch('handleJWT', {
          key: host.key
        }).then(JWT => {
          if (JWT != false) {
            next();
          } else {
            turnLogin(to, next);
            //ene uyed neg tiim 500 ch yumuu huudas ruu shideh
          }
        })
      } else if ('login' == to.name) {
        turnLogin(to, next);
      } else {
        turnLogin(to, next, true);
      }

      // store.dispatch('handleJWT', {
      //   key: host.key
      // }).then(JWT => {
      //   if (JWT != false){

      //   }
      //   else{
      //     //ene uyed neg tiim 500 ch yumuu huudas ruu shideh
      //   }
      // })
    }
  } else {
    //console.log('token bgaa ni', host.publicPage);
    if (to.matched.length == 0) {
      store.dispatch('handleRoutes', {
        router
      }).then(res => {
        let toPath = findRouteNameByPath(res, to.path);
        let profRoute = findRouteNameByPath(res, '/user/profile');
        let minv = parseInt(getConfigValueByKey(store.state.app.groupSettings, "anketReqPerc"), 10);
        let checkminv = parseInt(getConfigValueByKey(store.state.app.groupSettings, "anketCheckPerc"), 10);

        if (toPath != '') {
          if (toPath.meta.login) {
            if (store.state.user.userId != "") {
              //console.log("ened irsejbiunu")
              if (hasOneOf(['learningstudent'], store.state.user.access) && checkminv == 1 && minv > store.state.user.userInfo.anketTotal) {
                turnTo(profRoute, store.state.user.access, next, true)
              } else {
                turnTo(toPath, store.state.user.access, next, true)
              }
            } else {
              store.dispatch('handleUserInfo', {
                store: store
              }).then(user => {
                if (user != false) {
                  if (user.data.user_id == "") {
                    turnLogin(toPath, next, true);
                  } else {
                    store.dispatch('handleGroupSettings', {
                      store: store
                    }).then(sett => {
                      if (sett != false) {
                        store.dispatch('handleUsersettings', {
                          store: store
                        }).then(ustt => {
                          if (ustt != false) {
                            store.dispatch('handleGroupDefaultProjects', {
                              store: store
                            }).then(projects => {
                              if (projects != false) {
                                minv = parseInt(getConfigValueByKey(store.state.app.groupSettings, "anketReqPerc"), 10);
                                checkminv = parseInt(getConfigValueByKey(store.state.app.groupSettings, "anketCheckPerc"), 10);
                                if (hasOneOf(['learningstudent'], store.state.user.access) && checkminv == 1 && minv > store.state.user.userInfo.anketTotal) {
                                  store.dispatch('handleSignalR', {}).then(() => {
                                    turnProfile(to, next)
                                  }).catch(() => {
                                    turnProfile(to, next)
                                  });
                                } else {
                                  store.dispatch('handleSignalR', {}).then(() => {
                                    turnTo(toPath, store.state.user.access, next, true)
                                  }).catch(() => {
                                    turnTo(toPath, store.state.user.access, next, true)
                                  });
                                }
                              } else {
                                turnLogin(toPath, next, true);
                              }
                            })
                          } else {
                            turnLogin(toPath, next, true);
                          }
                        });
                      } else {
                        turnLogin(toPath, next, true);
                      }
                    })
                  }
                } else {
                  turnLogin(toPath, next, true);
                }
              }).catch(() => {
                turnLogin(toPath, next, true);
              });
            }
          } else {
            turnTo(toPath, store.state.user.access, next, true)
          }
        } else {
          turnLogin(toPath, next, true);
        }
      });
    } else if (to.meta.login) {
      let profRoute = findRouteNameByPath(store.state.app.dynamicRoutes, '/user/profile');
      let minv = parseInt(getConfigValueByKey(store.state.app.groupSettings, "anketReqPerc"), 10);
      let checkminv = parseInt(getConfigValueByKey(store.state.app.groupSettings, "anketCheckPerc"), 10);

      if (store.state.user.userId != "") {
        //console.log('*************************************** 1');
        if (hasOneOf(['learningstudent'], store.state.user.access) && checkminv == 1 && minv > store.state.user.userInfo.anketTotal) {
          //console.log('*************************************** 2', profRoute);
          //
          //console.log(profRoute.name, from.name);
          if (profRoute.name == from.name) {
            //console.log('*************************************** 3');

            store.dispatch('handleLoading', {
              isLoading: false
            });
            next(false)
            //turnTo(profRoute, store.state.user.access, next)
          } else {
            //next({name: profRoute.name)
            if (to.name == 'userProfile') {
              turnTo(to, store.state.user.access, next)
            } else
              turnProfile(to, next)
            //
          }
        } else {
          //console.log('*************************************** 3');
          turnTo(to, store.state.user.access, next)
        }
        //turnTo(to, store.state.user.access, next)
      } else {
        store.dispatch('handleUserInfo', {
          store: store
        }).then(user => {
          if (user != false) {
            if (user.data.user_id == "") {
              turnLogin(to, next, true);
            } else {
              store.dispatch('handleGroupDefaultProjects', {
                store: store
              }).then(projects => {
                if (projects != false) {
                  store.dispatch('handleRoutes', {
                    router: router
                  }).then(() => {
                    minv = parseInt(getConfigValueByKey(store.state.app.groupSettings, "anketReqPerc"), 10);
                    checkminv = parseInt(getConfigValueByKey(store.state.app.groupSettings, "anketCheckPerc"), 10);
                    if (hasOneOf(['learningstudent'], store.state.user.access) && checkminv == 1 && minv > store.state.user.userInfo.anketTotal) {
                      store.dispatch('handleSignalR', {}).then(() => {
                        turnTo(profRoute, store.state.user.access, next)
                      }).catch(() => {
                        turnTo(profRoute, store.state.user.access, next)
                      });
                    } else {
                      store.dispatch('handleSignalR', {}).then(() => {
                        turnTo(to, store.state.user.access, next)
                      }).catch(() => {
                        turnTo(to, store.state.user.access, next)
                      });
                    }
                  }).catch(() => {
                    turnLogin(to, next, true);
                  });
                } else {
                  turnLogin(to, next, true);
                }
              })
            }
          } else {
            turnLogin(to, next, true);
          }

        }).catch(() => {
          turnLogin(to, next, true);
        });
      }
    } else {
      if (host.publicPage != undefined && host.publicPage.has && store.state.user.userId == "") {
        if (host.publicPage.route == to.name ||
          (to.name == 'login' && from.name != null) ||
          (to.name == 'login') ||
          (to.name == 'vetLandingMeds') || (to.name == 'vetLandingLics') || (to.name == 'vetLandingHelp')
        ) {

          if (store.state.app.pages.length > 0) {
            turnTo(to, store.state.user.access, next);
            // next({
            //   name: host.publicPage.route,
            //   params: { id: store.state.app.homePageId }
            // })
          } else {

            store.dispatch('handlePages', {
              store: store
            }).then(page => {
              if (page != false) {
                turnTo(to, store.state.user.access, next);
                // next({
                //   name: host.publicPage.route,
                //   params: { id: store.state.app.homePageId }
                // })
              }
            });
          }
          //next()
          //turnTo(to, store.state.user.access, next);
        } else {

          // next({
          //   name: host.publicPage.route,
          //   params: {id: store.state.app.homePageId }
          // });
          if (hasOneOf(externalPages, [to.name])) {
            //console.log(to);
            //console.log("register bolon activation ruu nextley")
            manageMainLayoutConfig(to, store, true, true);
            next()
          } else {
            to.name = host.publicPage.route;
            to.params = {
              id: store.state.app.homePageId,
              cid: 0
            };
            turnTo(to, store.state.user.access, next, true);


            //turnTo(to, store.state.user.access, next, true);
          }
        }
      } else {
        //next();
        //console.log("what is this", to.name);



        if (hasOneOf(externalPages, [to.name])) {
          //console.log(to);
          //console.log("register bolon activation ruu nextley")
          manageMainLayoutConfig(to, store, true, true);
          next()
        } else {
          turnLogin(to, next, true);
          //turnTo(to, store.state.user.access, false);
        }
      }
    }
  }
})

router.afterEach(() => {
  store.dispatch('handleLoading', {
    isLoading: false
  });
  window.scrollTo(0, 0);
  // for (const route of to.matched) {
  //   if (route.params !=undefined && route.params.bot==500 && route.params.iid>0) {
  //     zoombt.use();
  //     zoomrs.use();
  //   }
  //   // else{
  //   //   zoombt.unuse();
  //   //   zoomrs.unuse();
  //   // }
  // }
})

export default router;